/**
 * Sanitize dynamic segments for Elbwalker action strings.
 * Keeps letters, numbers, hyphens; collapses other chars to a single hyphen.
 */
export const sanitizeElbKey = value =>
  String(value ?? '')
    .trim()
    .replace(/[^a-zA-Z0-9-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'unknown';

/**
 * Push a landing-page style click event to Elbwalker.
 * Matches declarative `data-elbaction="click:click …"` semantics (entity: page).
 */
export const trackElbClick = actionName => {
  if (typeof window === 'undefined' || typeof window.elb !== 'function') return;
  const action = String(actionName ?? '').trim();
  if (!action) return;
  window.elb(`page click ${action}`, {}, 'click');
};

/**
 * Register dynamically rendered DOM for Walker.js (visibility + click triggers).
 * Call after mount or when `data-elbaction` attributes change.
 */
export const initElbScope = scope => {
  if (typeof window === 'undefined' || typeof window.elb !== 'function' || !scope) return;
  window.elb('walker init', scope);
};
